/** Número-destaque: uma métrica por cartão, sem gráfico. O tom só pinta o ícone e nunca o
 *  número — valor e rótulo ficam em tinta de texto, como manda a regra de legibilidade. */
const CORES = {
  neutro: 'var(--wh-ink-2)',
  accent: 'var(--wh-accent)',
  sucesso: 'var(--wh-sucesso)',
  atencao: 'var(--wh-atencao)',
  critico: 'var(--wh-critico)',
};

export default function KpiCard({ icone, valor, label, hint, tom = 'neutro' }) {
  return (
    <div className="kpi-card">
      <div className="kpi-card__label">
        <i className={`bi ${icone}`} style={{ color: CORES[tom] || CORES.neutro }} aria-hidden="true" />
        {label}
      </div>
      <div className="kpi-card__value">{valor}</div>
      {hint && <div className="kpi-card__hint">{hint}</div>}
    </div>
  );
}
